import React from "react";

const skillCategories = [
  {
    category: "Languages",
    items: ["JavaScript", "TypeScript", "C++"],
  },
  {
    category: "Frontend",
    items: ["React.js", "HTML", "CSS", "Tailwind"],
  },
  {
    category: "Backend",
    items: ["Node.js", "Express.js", "WebSockets", "Nginx"],
  },
  {
    category: "Databases",
    items: ["PostgreSQL", "MongoDB", "Redis"],
  },
  {
    category: "AI & ML",
    items: ["GenAI APIs", "Ollama", "Claude", "RAG pipelines"],
  },
  {
    category: "DevOps & Tools",
    items: ["Git", "Docker", "PM2"],
  },
];

const Skills = () => {
  return (
    <section
      id="skills"
      className="layout-container py-24 md:py-32 border-t border-borderSubtle"
    >
      {/* Section Header */}
      <div className="flex flex-col">
        <span className="text-xs font-mono tracking-widest text-accent uppercase font-medium">
          <p>/ 02 / SKILLS</p>
        </span>
        <h2 className="text-xl font-normal text-white mt-2">Technical Stack</h2>
      </div>

      {/* Single-Column Category List */}
      <div className="flex flex-col gap-8 mt-12">
        {skillCategories.map(({ category, items }, index) => (
          <div
            key={index}
            className="flex flex-col md:flex-row md:items-center gap-4 md:gap-8 pb-6 border-b border-borderSubtle/50 last:border-b-0 last:pb-0"
          >
            {/* Category Name */}
            <span className="w-full md:w-48 text-xs font-mono tracking-widest text-zinc-500 uppercase font-medium">
              {category}
            </span>

            {/* Inline Pills */}
            <div className="flex flex-wrap gap-2.5">
              {items.map((item, idx) => (
                <span
                  key={idx}
                  className="px-3.5 py-1.5 border border-accent/30 text-white text-xs md:text-sm rounded-full transition-colors duration-300 hover:bg-accent/10 select-none font-normal"
                >
                  {item}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
